import React from 'react';
import PropTypes from 'prop-types';

import {
  Box,
  Button,
  Typography
} from '@mui/material';

import {
  CloudUploadOutlined
} from '@mui/icons-material';

import TabPanel from '@mui/lab/TabPanel';

import PatientDocumentList from '../PatientDocumentList/PatientDocumentList';

import {MessageIcon} from '../../../../../Common/components/Icons/icons';

import {
  actionIconSx,
  documentsActionsSx,
  documentsHeaderSx,
  documentsTitleSx,
  documentsTitleWrapperSx,
  documentsWrapperSx,
  messageButtonSx,
  recordsCountSx,
  tabPanelSx,
  uploadButtonSx
} from './SoapLeftStyles';

const DocumentsTabPanel = ({
  onMessage,
  onUpload
}) => {
  return (
    <TabPanel
      value="4"
      sx={tabPanelSx}>
      <Box sx={documentsWrapperSx}>
        <Box sx={documentsHeaderSx}>
          <Box sx={documentsTitleWrapperSx}>
            <Typography sx={documentsTitleSx}>
              Documents
            </Typography>

            <Box sx={recordsCountSx}>
              30 Records
            </Box>
          </Box>

          <Box sx={documentsActionsSx}>
            <Button
              variant="outlined"
              size="small"
              onClick={onMessage}
              startIcon={
                <MessageIcon sx={actionIconSx} />
              }
              sx={messageButtonSx}>
              Message
            </Button>

            <Button
              variant="outlined"
              size="small"
              onClick={onUpload}
              startIcon={
                <CloudUploadOutlined />
              }
              sx={uploadButtonSx}>
              Upload Document
            </Button>
          </Box>
        </Box>

        <PatientDocumentList />
      </Box>
    </TabPanel>
  );
};

DocumentsTabPanel.propTypes = {
  onMessage: PropTypes.func.isRequired,
  onUpload: PropTypes.func.isRequired
};

export default DocumentsTabPanel;